import VComp from '@vue/composition-api'
import Vue from 'vue'

Vue.use(VComp)
